import axios from 'axios';
import $url from '../urls';

const handleHttp = function () {
  let instance;
  init({
    timeout: 5000
  });

  function init(options) {
    instance = axios.create(options);
  }

  function ajaxCommon(params) {
    const url = params.url;
    let sendParam = {};

    switch (params.method) {
      case 'put':
        if (Object.prototype.toString.call(params.data) === '[object FormData]') {
          sendParam = params.data;
        } else {
          sendParam = $url.initDel(params.data);
        }

        break;

      case 'get':
        params.config.params = $url.initSearchDel(params.data);
        break;

      case 'search':
        params.method = 'post';
        sendParam = $url.initSearchDel(params.data);
        break;

      case 'post':
        if (Object.prototype.toString.call(params.data) === '[object FormData]') {
          sendParam = params.data;
        } else {
          sendParam = $url.initDel(params.data);
        }

        break;

      case 'patch':
        sendParam = $url.initDel(params.data);
        break;

      case 'delete':
        sendParam = $url.initDel(params.data);
        params.config.data = sendParam;
        break;

      default:
        break;
    }

    if (['post', 'patch', 'put'].includes(params.method)) {
      return instance[params.method](url, sendParam, params.config);
    } else {
      return instance[params.method](url, params.config);
    }
  }

  function get(url, params = {}, config = {}) {
    return ajaxCommon({
      method: 'get',
      url,
      data: params,
      config
    });
  }

  function post(url, params = {}, config = {}) {
    return ajaxCommon({
      method: 'post',
      url,
      data: params,
      config
    });
  }

  function put(url, params = {}, config = {}) {
    return ajaxCommon({
      method: 'put',
      url,
      data: params,
      config
    });
  }

  function patch(url, params = {}, config = {}) {
    return ajaxCommon({
      method: 'patch',
      url,
      data: params,
      config
    });
  }

  function del(url, params = {}, config = {}) {
    return ajaxCommon({
      method: 'delete',
      url,
      data: params,
      config
    });
  }

  function search(url, params = {}, config = {}) {
    return ajaxCommon({
      method: 'search',
      url,
      data: params,
      config
    });
  }

  function addResInterceptors(inters) {
    const arr = [];

    for (let i = 0; i < inters.length; i++) {
      if (inters[i].length > 1) {
        arr.push(instance.interceptors.response.use(inters[i][0], inters[i][1]));
      } else {
        arr.push(instance.interceptors.response.use(inters[i][0]));
      }
    }

    return arr;
  }

  function addReqInterceptors(inters) {
    const arr = [];

    for (let i = inters.length - 1; i >= 0; i--) {
      if (inters[i].length > 1) {
        arr.push(instance.interceptors.request.use(inters[i][0], inters[i][1]));
      } else {
        arr.push(instance.interceptors.request.use(inters[i][0]));
      }
    }

    return arr;
  }

  function ejectInterceptors(type, inters) {
    if (type === 'response') {
      for (let i = 0; i < inters.length; i++) {
        instance.interceptors.response.eject(inters[i]);
      }
    }

    if (type === 'request') {
      for (let i = 0; i < inters.length; i++) {
        instance.interceptors.request.eject(inters[i]);
      }
    }
  }

  function getAjaxInstance() {
    instance.$get = get;
    instance.$post = post;
    instance.$put = put;
    instance.$patch = patch;
    instance.$del = del;
    instance.$search = search;
    instance.$addReqInterceptors = addReqInterceptors;
    instance.$addResInterceptors = addResInterceptors;
    instance.$ejectInterceptors = ejectInterceptors;
    instance.$cancelToken = axios.CancelToken;
    return instance;
  }

  return {
    init,
    $post: post,
    $put: put,
    $get: get,
    $del: del,
    $patch: patch,
    $search: search,
    getAjaxInstance,
    addResInterceptors,
    addReqInterceptors,
    ejectInterceptors
  };
}();

export default handleHttp;